import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BrowserBackService {
  constructor(private _router: Router) {}

  /**
   * ブラウザバック(フォワード)を検知して値を流すObservableを返却する
   * @returns ブラウザバック時に値が流れるObservable
   */
  public watchBrowserBack() {
    return this._router.events.pipe(
      filter((e): e is NavigationStart => e instanceof NavigationStart),
      filter(({ navigationTrigger: trigger }) => trigger === 'popstate')
    );
  }
}
